module.exports = __webpack_public_path__ + "img/物联网.24ad0663.png";